module.exports = __webpack_public_path__ + "img/icon1.e61effb9.png";